/* FUN GUY — homepage section behaviour (carousels, pack picker, add to cart). */
(() => {
  if (window.fgHomeLoaded) return;
  window.fgHomeLoaded = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = cents => {
    const fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: fmt }).format(cents / 100);
  };

  let toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fg-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('fg-show');
    clearTimeout(toast.t);
    toast.t = setTimeout(() => toastEl.classList.remove('fg-show'), 2400);
  }

  // The store's cart is Rebuy Smart Cart (the header bag calls Rebuy.SmartCart.show()).
  // Refresh Rebuy's copy of the cart and slide it open. If Rebuy hasn't loaded, fall back
  // to Shapes' own cart refresh event and report back with a toast instead.
  async function refreshThemeCart() {
    const rebuy = window.Rebuy;
    if (rebuy && rebuy.Cart && rebuy.SmartCart) {
      await new Promise(resolve => {
        try { rebuy.Cart.fetchCart(resolve); } catch (e) { resolve(); }
        setTimeout(resolve, 1500);
      });
      rebuy.SmartCart.show();
      return true;
    }
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
    return false;
  }

  function scrollByCard(track, dir) {
    const card = track.firstElementChild;
    if (!card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 14;
    track.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }

  const currentQty = card => +((card.querySelector('.fg-pack[aria-pressed="true"]') || { dataset: { qty: 1 } }).dataset.qty);

  function renderPrices(card) {
    const price = +card.dataset.price;
    card.querySelector('[data-price]').textContent = money(price * currentQty(card));
    card.querySelectorAll('.fg-pack').forEach(b => {
      const el = b.querySelector('[data-pack-price]');
      if (el) el.textContent = money(price * +b.dataset.qty);
    });
  }

  // Flavour / size pickers: match the chosen options to a variant, then update price + stock.
  document.addEventListener('change', e => {
    const select = e.target.closest('.fg-products [data-fg-option]');
    if (!select) return;
    const card = select.closest('.fg-card');
    const data = card.querySelector('[data-fg-variants]');
    if (!data) return;
    const chosen = [...card.querySelectorAll('[data-fg-option]')].map(s => s.value);
    const variant = JSON.parse(data.textContent).find(v => v.options.every((o, i) => o === chosen[i]));
    const add = card.querySelector('.fg-add');
    if (!variant) {
      add.disabled = true; add.textContent = 'Unavailable';
      return;
    }
    card.dataset.variant = variant.id;
    card.dataset.price = variant.price;
    renderPrices(card);
    add.disabled = !variant.available;
    add.textContent = variant.available ? add.dataset.label : 'Sold out';
  });

  document.addEventListener('click', async e => {
    const arrow = e.target.closest('[data-fg-scroll]');
    if (arrow) {
      const track = document.getElementById(arrow.getAttribute('aria-controls'));
      if (track) scrollByCard(track, +arrow.dataset.fgScroll);
      return;
    }

    const pack = e.target.closest('.fg-products .fg-pack');
    if (pack) {
      const card = pack.closest('.fg-card');
      card.querySelectorAll('.fg-pack').forEach(b => b.setAttribute('aria-pressed', b === pack));
      renderPrices(card);
      return;
    }

    const add = e.target.closest('.fg-products .fg-add');
    if (add) {
      const card = add.closest('.fg-card');
      const section = add.closest('[data-after-add]');
      const qty = currentQty(card);
      add.disabled = true;
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +card.dataset.variant, quantity: qty }] })
        });
        if (!res.ok) throw new Error((await res.json()).description || 'Could not add to bag');
        if (section && section.dataset.afterAdd === 'cart') { window.location.href = root + 'cart'; return; }
        if (!(await refreshThemeCart())) toast(`Added ${qty} × ${card.dataset.title} to your bag`);
      } catch (err) {
        toast(err.message);
      } finally {
        add.disabled = false;
      }
    }
  });
})();
